import { LOGOUT_REQUEST } from '@sit/client-shared';
import { takeEvery } from 'redux-saga/effects';
import {
  approveDeclineByTimesheetsOrEntriesAsyncRequestSaga,
  getDoneApprovalsAllNextPageRequestSaga,
  getDoneApprovalsAllRequestSaga,
  getDoneApprovalsTimesheetNextPageRequestSaga,
  getDoneApprovalsTimesheetRequestSaga,
  getTodoApprovalsActiveNextPageRequestSaga,
  getTodoApprovalsActiveRequestSaga,
  getTodoApprovalsGroupsNextPageRequestSaga,
  getTodoApprovalsGroupsRequestSaga,
  getTodoApprovalsSelectedNextPageRequestSaga,
  getTodoApprovalsSelectedRequestSaga,
} from './Approvals/sagas';
import * as ApprovalsTypes from './Approvals/types';
import * as ClientsActionDefinitions from './Clients/actionDefinitions';
import { getClientsRequestSaga } from './Clients/sagas';
import {
  deleteClusterNodeRequestSaga,
  getClustersRequestSaga,
  splitClusterAndAssignToEntryRequestSaga,
  splitClusterAndOpenClusterAssignModalSaga,
  splitClusterRequestSaga,
  updateClusterNodeRequestSaga,
  updateClusterOverlapsRequestSaga,
  updateClusterRequestSaga,
} from './Clusters/sagas';
import * as ClustersTypes from './Clusters/types';
import { getItemsRequestSaga } from './Items/sagas';
import * as ItemsTypes from './Items/types';
import * as ProjectsActionDefinitions from './Projects/actionDefinitions';
import { getProjectsOfClientRequestSaga, getProjectsRequestSaga } from './Projects/sagas';
import * as TasksActionDefinitions from './Tasks/actionDefinitions';
import { getTasksOfProjectRequestSaga } from './Tasks/sagas';
import {
  getTimesheetRequestSaga,
  saveTimesheetRequestAsyncSaga,
  saveTimesheetRequestAsyncSagaFailure,
  saveTimesheetRequestAsyncSagaSuccess,
  submitTimesheetRequestSagaAsyncFailure,
  submitTimesheetRequestSagaAsyncSuccess,
} from './Timesheet/sagas';
import * as TimesheetTypes from './Timesheet/types';
import * as TimesheetEntriesTypes from './TimesheetEntries/actionDefinitions';
import {
  createEntryAndAssignClusterRequestSaga,
  createEntryAndAssignNodeRequestSaga,
  createTimesheetEntryRequestSaga,
  deleteTimesheetEntryRequestSaga,
  getTimesheetEntriesRequestSaga,
  updateTimesheetEntryRequestSaga,
} from './TimesheetEntries/sagas';
import {
  createTimesheetRowRequestSaga,
  deleteTimesheetRowRequestSaga,
  getTimesheetRowRequestSaga,
  getTimesheetRowsRequestSaga,
  toggleRowBillableRequestSaga,
  updateTimesheetRowRequestSaga,
} from './TimesheetRows/sagas';
import * as TimesheetRowsTypes from './TimesheetRows/types';
import {
  getUserRequestSaga,
  loginRequestSaga,
  logoutRequestSaga,
  registerEmployeeRequestSaga,
  registerResendEmailRequestSaga,
  sendFallbackMfaCodeRequestSaga,
  updateAccessToken,
  updatePasswordRequestSaga,
  updateUserRequestSaga,
} from './User/sagas';
import * as UserTypes from './User/types';

export function* watchSagas() {
  yield takeEvery(
    ApprovalsTypes.APPROVE_DECLINE_BY_TIMESHEETS_OR_ENTRIES_ASYNC_REQUEST,
    approveDeclineByTimesheetsOrEntriesAsyncRequestSaga,
  );
  yield takeEvery(ApprovalsTypes.GET_DONE_APPROVALS_TIMESHEET_REQUEST, getDoneApprovalsTimesheetRequestSaga);
  yield takeEvery(ApprovalsTypes.GET_DONE_APPROVALS_ALL_REQUEST, getDoneApprovalsAllRequestSaga);
  yield takeEvery(ApprovalsTypes.GET_DONE_APPROVALS_ALL_NEXT_PAGE_REQUEST, getDoneApprovalsAllNextPageRequestSaga);
  yield takeEvery(ApprovalsTypes.GET_DONE_APPROVALS_TIMESHEET_NEXT_PAGE_REQUEST, getDoneApprovalsTimesheetNextPageRequestSaga);
  yield takeEvery(ApprovalsTypes.GET_TODO_APPROVALS_ACTIVE_REQUEST, getTodoApprovalsActiveRequestSaga);
  yield takeEvery(ApprovalsTypes.GET_TODO_APPROVALS_ACTIVE_NEXT_PAGE_REQUEST, getTodoApprovalsActiveNextPageRequestSaga);
  yield takeEvery(ApprovalsTypes.GET_TODO_APPROVALS_SELECTED_REQUEST, getTodoApprovalsSelectedRequestSaga);
  yield takeEvery(ApprovalsTypes.GET_TODO_APPROVALS_SELECTED_NEXT_PAGE_REQUEST, getTodoApprovalsSelectedNextPageRequestSaga);
  yield takeEvery(ApprovalsTypes.GET_TODO_APPROVALS_GROUPS_REQUEST, getTodoApprovalsGroupsRequestSaga);
  yield takeEvery(ApprovalsTypes.GET_TODO_APPROVALS_GROUPS_NEXT_PAGE_REQUEST, getTodoApprovalsGroupsNextPageRequestSaga);

  yield takeEvery(ClientsActionDefinitions.GET_CLIENTS_REQUEST, getClientsRequestSaga);

  yield takeEvery(ClustersTypes.DELETE_CLUSTER_NODE_REQUEST, deleteClusterNodeRequestSaga);
  yield takeEvery(ClustersTypes.GET_CLUSTERS_REQUEST, getClustersRequestSaga);
  yield takeEvery(ClustersTypes.SPLIT_CLUSTER_REQUEST, splitClusterRequestSaga);
  yield takeEvery(ClustersTypes.SPLIT_CLUSTER_AND_OPEN_CLUSTER_ASSIGN_MODAL_REQUEST, splitClusterAndOpenClusterAssignModalSaga);
  yield takeEvery(ClustersTypes.SPLIT_CLUSTER_AND_ASSIGN_TO_ENTRY_REQUEST, splitClusterAndAssignToEntryRequestSaga);
  yield takeEvery(ClustersTypes.UPDATE_CLUSTER_OVERLAPS_REQUEST, updateClusterOverlapsRequestSaga);
  yield takeEvery(ClustersTypes.UPDATE_CLUSTER_NODE_REQUEST, updateClusterNodeRequestSaga);
  yield takeEvery(ClustersTypes.UPDATE_CLUSTER_REQUEST, updateClusterRequestSaga);

  yield takeEvery(ItemsTypes.GET_ITEMS_REQUEST, getItemsRequestSaga);

  yield takeEvery(ProjectsActionDefinitions.GET_PROJECTS_REQUEST, getProjectsRequestSaga);
  yield takeEvery(ProjectsActionDefinitions.GET_PROJECTS_OF_CLIENT_REQUEST, getProjectsOfClientRequestSaga);

  yield takeEvery(TasksActionDefinitions.GET_TASKS_OF_PROJECT_REQUEST, getTasksOfProjectRequestSaga);

  yield takeEvery(TimesheetTypes.GET_TIMESHEET_REQUEST, getTimesheetRequestSaga);
  yield takeEvery(TimesheetTypes.SUBMIT_TIMESHEET_REQUEST_ASYNC_SUCCESS, submitTimesheetRequestSagaAsyncSuccess);
  yield takeEvery(TimesheetTypes.SUBMIT_TIMESHEET_REQUEST_ASYNC_FAILURE, submitTimesheetRequestSagaAsyncFailure);
  yield takeEvery(TimesheetTypes.SAVE_TIMESHEET_REQUEST_ASYNC, saveTimesheetRequestAsyncSaga);
  yield takeEvery(TimesheetTypes.SAVE_TIMESHEET_REQUEST_ASYNC_SUCCESS, saveTimesheetRequestAsyncSagaSuccess);
  yield takeEvery(TimesheetTypes.SAVE_TIMESHEET_REQUEST_ASYNC_FAILURE, saveTimesheetRequestAsyncSagaFailure);

  yield takeEvery(TimesheetEntriesTypes.CREATE_TIMESHEET_ENTRY_REQUEST, createTimesheetEntryRequestSaga);
  yield takeEvery(TimesheetEntriesTypes.CREATE_ENTRY_AND_ASSIGN_CLUSTER_REQUEST, createEntryAndAssignClusterRequestSaga);
  yield takeEvery(TimesheetEntriesTypes.CREATE_ENTRY_AND_ASSIGN_NODE_REQUEST, createEntryAndAssignNodeRequestSaga);
  yield takeEvery(TimesheetEntriesTypes.DELETE_TIMESHEET_ENTRY_REQUEST, deleteTimesheetEntryRequestSaga);
  yield takeEvery(TimesheetEntriesTypes.GET_TIMESHEET_ENTRIES_REQUEST, getTimesheetEntriesRequestSaga);
  yield takeEvery(TimesheetEntriesTypes.UPDATE_TIMESHEET_ENTRY_REQUEST, updateTimesheetEntryRequestSaga);

  yield takeEvery(TimesheetRowsTypes.CREATE_TIMESHEET_ROW_REQUEST, createTimesheetRowRequestSaga);
  yield takeEvery(TimesheetRowsTypes.DELETE_TIMESHEET_ROW_REQUEST, deleteTimesheetRowRequestSaga);
  yield takeEvery(TimesheetRowsTypes.GET_TIMESHEET_ROW_REQUEST, getTimesheetRowRequestSaga);
  yield takeEvery(TimesheetRowsTypes.GET_TIMESHEET_ROWS_REQUEST, getTimesheetRowsRequestSaga);
  yield takeEvery(TimesheetRowsTypes.TOGGLE_ROW_BILLABLE_REQUEST, toggleRowBillableRequestSaga);
  yield takeEvery(TimesheetRowsTypes.UPDATE_TIMESHEET_ROW_REQUEST, updateTimesheetRowRequestSaga);

  yield takeEvery(UserTypes.GET_USER_REQUEST, getUserRequestSaga);
  yield takeEvery(UserTypes.LOGIN_REQUEST, loginRequestSaga);
  yield takeEvery(LOGOUT_REQUEST, logoutRequestSaga);
  yield takeEvery(UserTypes.REGISTER_RESEND_EMAIL_REQUEST, registerResendEmailRequestSaga);
  yield takeEvery(UserTypes.REGISTER_EMPLOYEE_REQUEST, registerEmployeeRequestSaga);
  yield takeEvery(UserTypes.SEND_FALLBACK_MFA_CODE_REQUEST, sendFallbackMfaCodeRequestSaga);
  yield takeEvery(UserTypes.UPDATE_PASSWORD_REQUEST, updatePasswordRequestSaga);
  yield takeEvery(UserTypes.UPDATE_USER_REQUEST, updateUserRequestSaga);
  yield takeEvery(UserTypes.UPDATE_ACCESS_TOKEN, updateAccessToken);
}
